import Vue from 'vue';
import { axClient } from "../mixins/axios-mixins";

Vue.component('activation-code-form', {
    data: function () {
        return {
            code: "",
            buttonDisabled: false,
            showError: false
        }
    },
    methods: {
        doIt: function () {
            let vm = this;
            vm.buttonDisabled = true;
            axClient.post("/login/activationcode", {code:vm.code},
            function(resp) {
                window.location.reload();
            },
            function(resp) {
                vm.buttonDisabled = false;
                vm.showError = true;
            });
        }
    }
});